namespace constant.search {
    // 1ページあたりの表示件数
    export const PAGE_VIEW_LIMIT = 200;

    // キーワード出現箇所の最大表示件数
    export const INNER_VIEW_LIMIT = 50;

    // 年度リスト
    export const FISCAL_YEAR_LIST= [
        {value:'2026', text:'令和8'},
        {value:'2025', text:'令和7'},
        {value:'2024', text:'令和6'},
        {value:'2023', text:'令和5'},
        {value:'2022', text:'令和4'},
        {value:'2021', text:'令和3'},
        {value:'2020', text:'令和2'},
        {value:'2019', text:'令和元'},
        {value:'2018', text:'平成30'},
        {value:'2017', text:'平成29'},
        {value:'2016', text:'平成28'},
        {value:'2015', text:'平成27'},
        {value:'2014', text:'平成26'},
        {value:'2013', text:'平成25'},
        {value:'2012', text:'平成24'},
        {value:'2011', text:'平成23'},
        {value:'2010', text:'平成22'},
        {value:'2009', text:'平成21'},
        {value:'2008', text:'平成20'},
        {value:'2007', text:'平成19'},
        {value:'2006', text:'平成18'},
        {value:'2005', text:'平成17'},
        {value:'2004', text:'平成16'},
        {value:'2003', text:'平成15'},
        {value:'2002', text:'平成14'},
        {value:'2001', text:'平成13'},
        {value:'2000', text:'平成12'},
        {value:'1999', text:'平成11'},
        {value:'1998', text:'平成10'},
        {value:'1997', text:'平成9'},
        {value:'1996', text:'平成8'},
        {value:'1995', text:'平成7'},
        {value:'1994', text:'平成6'},
        {value:'1993', text:'平成5'},
        {value:'1992', text:'平成4'},
        {value:'1991', text:'平成3'},
        {value:'1990', text:'平成2'},
        {value:'1989', text:'平成元'},
        {value:'1988', text:'昭和63'},
        {value:'1987', text:'昭和62'},
        {value:'1986', text:'昭和61'},
        {value:'1985', text:'昭和60'},
        {value:'1984', text:'昭和59'},
        {value:'1983', text:'昭和58'},
        {value:'1982', text:'昭和57'},
        {value:'1981', text:'昭和56'},
        {value:'1980', text:'昭和55'},
        {value:'1979', text:'昭和54'},
        {value:'1978', text:'昭和53'},
        {value:'1977', text:'昭和52'},
        {value:'1976', text:'昭和51'},
        {value:'1975', text:'昭和50'},
        {value:'1974', text:'昭和49'},
        {value:'1973', text:'昭和48'},
        {value:'1972', text:'昭和47'},
        {value:'1971', text:'昭和46'},
        {value:'1970', text:'昭和45'},
        {value:'1969', text:'昭和44'},
    ];
}

namespace constant.document {
    // 予算種別
    export const TYPE_OF_BUDGET_SEARCH_ITEMLIST: {[key:string]: string} = {
        "01": "当初予算",
        "02": "補正予算",
        "03": "暫定予算"
    };

    // 予算書情報
    export const TYPE_OF_BUDGET_YOSAN_ITEMLIST: {[key:number]: string} = {
        0: "一般会計",
        1: "特別会計",
        2: "政府関係機関",
        3: "財政法第２８条等"
    };

    // 予算書情報（所管）
    export const RUNNING_TITLE_YOSAN_ITEMLIST1: {[key:number]: string} = {
        // 一般会計
        0: "皇室費",
        1: "国会",
        2: "裁判所",
        3: "会計検査院",
        4: "内閣",
        5: "内閣府",
        6: "デジタル庁",
        7: "総務省",
        8: "法務省",
        9: "外務省",
        10: "財務省",
        11: "文部科学省",
        12: "厚生労働省",
        13: "農林水産省",
        14: "経済産業省",
        15: "国土交通省",
        16: "環境省",
        17: "防衛省",
        18: "総理府",
        19: "大蔵省",
        20: "文部省",
        21: "厚生省",
        22: "農林省",
        23: "通商産業省",
        24: "運輸省",
        25: "郵政省",
        26: "労働省",
        27: "建設省",
        28: "自治省",
        29: "防災庁",
    };

    export const RUNNING_TITLE_YOSAN_ITEMLIST2: {[key:number]: string} = {
        // 特別会計
        0: "総務省",
        1: "法務省",
        2: "財務省",
        3: "文部科学省",
        4: "厚生労働省",
        5: "農林水産省",
        6: "経済産業省",
        7: "国土交通省",
        8: "内閣府、総務省及び財務省",
        9: "内閣府及び厚生労働省",
        10: "財務省、文部科学省及び経済産業省",
        11: "財務省、経済産業省及び環境省",
        12: "財務省及び国土交通省",
        13: "文部科学省、経済産業省及び環境省",
        14: "内閣府、文部科学省、経済産業省及び環境省",
        15: "国会、裁判所、会計検査院、内閣、内閣府、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省",
        16: "国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省",
        17: "大蔵省",
        18: "文部省",
        19: "厚生省",
        20: "農林省",
        21: "通商産業省",
        22: "運輸省",
        23: "郵政省",
        24: "労働省",
        25: "建設省",
        26: "総理府、大蔵省及び通商産業省",
        27: "総理府、大蔵省及び自治省",
        28: "大蔵省及び自治省",
        29: "大蔵省、通商産業省及び労働省",
        30: "大蔵省及び建設省",
        31: "大蔵省、運輸省及び建設省",
        32: "国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、防災庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省",
    };

    // 決算書情報
    export const TYPE_OF_BUDGET_KESSAN_ITEMLIST: {[key:number]: string} = {
        0: "一般会計歳入歳出決算",
        1: "国税収納金整理資金受払計算書",
        2: "決算調整資金からの歳入組入れに関する調書",
        3: "特別会計歳入歳出決算",
        4: "政府関係機関決算書",
        5: "決算参照",
        6: "特別会計決算参照書",
        7: "物品増減及び現在額総報告",
        8: "各省各庁物品増減及び現在額報告書",
        9: "国の債権の現在額総報告",
        10: "各省各庁債権現在額報告書",
    };

    // 決算書情報（所管）
    export const RUNNING_TITLE_KESSAN_ITEMLIST1: {[key:number]: string} = {
        // 一般会計
        0: "皇室費",
        1: "国会",
        2: "裁判所",
        3: "会計検査院",
        4: "内閣",
        5: "内閣府",
        6: "デジタル庁",
        7: "復興庁",
        8: "総務省",
        9: "法務省",
        10: "外務省",
        11: "財務省",
        12: "文部科学省",
        13: "厚生労働省",
        14: "農林水産省",
        15: "経済産業省",
        16: "国土交通省",
        17: "環境省",
        18: "防衛省",
        19: "総理府",
        20: "大蔵省",
        21: "文部省",
        22: "厚生省",
        23: "農林省",
        24: "通商産業省",
        25: "運輸省",
        26: "郵政省",
        27: "労働省",
        28: "建設省",
        29: "自治省",
        30: "防災庁",
    };

    export const RUNNING_TITLE_KESSAN_ITEMLIST2: {[key:number]: string} = {
        // 特別会計
        0: "総務省",
        1: "法務省",
        2: "財務省",
        3: "文部科学省",
        4: "厚生労働省",
        5: "農林水産省",
        6: "経済産業省",
        7: "国土交通省",
        8: "内閣府、総務省及び財務省",
        9: "内閣府及び厚生労働省",
        10: "財務省、文部科学省及び経済産業省",
        11: "財務省、経済産業省及び環境省",
        12: "財務省及び国土交通省",
        13: "文部科学省、経済産業省及び環境省",
        14: "内閣府、文部科学省、経済産業省及び環境省",
        15: "国会、裁判所、会計検査院、内閣、内閣府、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省",
        16: "国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省",
        17: "大蔵省",
        18: "文部省",
        19: "厚生省",
        20: "農林省",
        21: "通商産業省",
        22: "運輸省",
        23: "郵政省",
        24: "労働省",
        25: "建設省",
        26: "総理府、大蔵省及び通商産業省",
        27: "総理府、大蔵省及び自治省",
        28: "大蔵省及び自治省",
        29: "大蔵省、通商産業省及び労働省",
        30: "大蔵省及び建設省",
        31: "大蔵省、運輸省及び建設省",
        32: "国会、裁判所、会計検査院、内閣、内閣府、デジタル庁、防災庁、復興庁、総務省、法務省、外務省、財務省、文部科学省、厚生労働省、農林水産省、経済産業省、国土交通省、環境省及び防衛省",
    };

    export const DISPLAY_ORDER_ITEMS: {[key:string]: string} = {
        "01":"暫定予算",
        "02":"暫定補正予算",
        "03":"当初予算",
        "04":"補正予算（第１号）",
        "05":"補正予算（第２号）",
        "06":"補正予算（第３号）",
        "07":"補正予算（第４号）",
        "08":"補正予算（第５号）",
        "09":"補正予算（第６号）",
        "10":"補正予算（第７号）",
        "11":"補正予算（第８号）",
        "12":"補正予算（第９号）",
        "13":"補正予算（第１０号）",
        "99":"決算",
    };
}

export default constant;